export const findHighestLevelBelowReadingLevel = (
  sortedContentLevels,
  readingLevelLexileRange,
  language,
) => {
  const levelsBelowReadingLevel = sortedContentLevels.filter((level) => {
    if (language) {
      return (
        level.raw_lexile < readingLevelLexileRange[0] &&
        level.language === language
      );
    }

    return level.raw_lexile < readingLevelLexileRange[0];
  });

  return levelsBelowReadingLevel[levelsBelowReadingLevel.length - 1];
};
